import { useNavigate } from "react-router-dom";
import "./Banner.css"; // Import the CSS file for styling

const Banner = () => {
  const navigate = useNavigate(); // Initialize the navigate function
  const handleBookTaxiClick = () => {
    navigate("/packages");
  };

  return (
    <div className="banner-container">
      <img
        className="banner-image"
        src="images/cta.jpg"
        alt="Taxi Banner"
      />
      
      {/* Black overlay between image and content */}
      <div className="banner-overlay"></div>

      <div className="banner-content">
        <h1>The Most Trusted Taxi Company in Saudi Arabia</h1>
        <p>
          Our Umrah taxi service offers affordable, safe, and reliable
          transportation throughout Saudi Arabia, especially for Hajj and Umrah
          pilgrims.
        </p>
        <button onClick={handleBookTaxiClick}>Book Taxi</button>
      </div>
    </div>
  );
};

export default Banner;
